import { getGACompanyName, getGARoleName } from '../../User/utils';

import env from '../../../../env';

/**
 * @param {object} user User data
 * @returns {null}
 */
export const setGAUser = (user) => {
  if (!user?.id) return null;

  window.gtag('config', env?.GA4ID, {
    user_id: user.id,
  });

  window.gtag('set', 'user_properties', {
    crm_id: user.id,
    role: getGARoleName(user),
    company: getGACompanyName(user),
  });

  return null;
};

/**
 * @param {string} eventName Event name
 * @param {object} data Event extra data
 * @returns {null}
 */
export const sendGA4Event = (eventName, data) => {
  if (!window.gtag) return null;
  window.gtag('event', eventName, data);
  return null;
};
